// extracted by mini-css-extract-plugin
export var List = "FAQ-module--List--1B7vL";
export var ListItem = "FAQ-module--ListItem--3OnlG";
export var ListItemShippingFrance = "FAQ-module--ListItemShippingFrance--2j8zo";
export var ListItemPayment = "FAQ-module--ListItemPayment--3iRGF";
export var ListItemMessage = "FAQ-module--ListItemMessage--1aLAL";
export var ListItemWhatsapp = "FAQ-module--ListItemWhatsapp--CmLt3";
export var ListItemMessageLink = "FAQ-module--ListItemMessageLink--2ryLa";
export var ArtworkMoon = "FAQ-module--ArtworkMoon--2gTUf";
export var ArtworkSun = "FAQ-module--ArtworkSun--a4kpu";